import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "../tabPanel/tabPanel";
import LmstableData from "../../../../library/custom/lmstableData/lmstableData";
import "./coursesList.scss";
import { useSelector, useDispatch } from "react-redux";
import { COLUMNS_COURSES_VIEW } from "../../courseConstant";
import TableRowAction from "../../../../library/custom/gridTable/TableRowAction";
import { useNavigate } from "react-router-dom";
import * as lmsAction from "../../../../redux/actions/lmsAction";
import { COURSESDETAIL } from "../../../../constant/routeContant";
import SearchIcon from "@mui/icons-material/Search";
import { useLocation } from "react-router-dom";

import {
  GRID_DEFAULT_PAGE_SIZE,
  ORG_ID,
  USER_ID,
  API_STATUS,
  HBNEXT_ORG_ID,
  LOGIN_ORG_ID,
  SEFETY_HBN_CLIENT_PARTNER_PRI,
  SW_HBN_CLIENT_PARTNER_PRI,
  ACTIVE_INACTIVE,
} from "../../../../constant/constant";
import DialogBox from "../../../../library/common/DialogBox";
import {
  checkPrivileges,
  hasAllPrivileges,
  showRighSideMenu,
} from "../../../../utils/rolesHelper";
import downloadIcon from "../../../../assets/downloadIcon.svg";
import { InactiveClient } from "../../../../utils/helper";
import FilterCommonStatusSelect from "../../../admin/shared/FilterCommonStatusSelect";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useDebounce } from "../../../../utils/useDebounceSearch";

const CoursesList = (props) => {
  const initialTabValue = props?.courseListData?.filterObj?.status
    ? props?.courseListData?.filterObj?.status
    : (props?.defaultTabValue ?? 0);
  const [selectActive, setSelectActive] = useState();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(GRID_DEFAULT_PAGE_SIZE);
  const [value, setValue] = React.useState(initialTabValue);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getCoursesListData = props?.getCoursesListData;
  const { isLoading } = useSelector((state) => state.getCoursesList);
  // const [status, setStatus] = useState(initialTabValue);
  const CoursedeleteStatus = props?.CoursedeleteStatus;
  const publishCourseStatus = props?.publishCourseStatus;
  const courseListData = props?.courseListData;
  const [open, setOpen] = useState(false);
  const categoryListData = props?.categoryListData;
  const deleteCourse = props?.deleteCourse;
  const location = useLocation();

  const setisdisable = props?.setisdisable;
  const isdisable = props?.isdisable;
  const [selectedValue, setSelectedValue] = useState();
  const [isTableLoading, setisTableLoading] = useState(false);
  const [activeInActive, setActiveInActive] = useState({
    ACTIVE: false,
    INACTIVE: false,
  });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [search, setSearch] = useState("");

  useEffect(() => {
    setValue(initialTabValue);
    //  setStatus(initialTabValue);
  }, [initialTabValue]);

  const handleActiveInActiveChange = (event) => {
    setSelectActive(event.target.value);
    const { value } = event.target;
    setActiveInActive((prevState) => {
      if (!prevState) return { ACTIVE: false, INACTIVE: false };
      const newState = {
        ...prevState,
        [value]: !prevState[value],
      };
      let status = "";
      if (newState.ACTIVE && !newState.INACTIVE) {
        status = true;
      } else if (!newState.ACTIVE && newState.INACTIVE) {
        status = false;
      }
      if (!newState.ACTIVE && !newState.INACTIVE) {
        dispatch(lmsAction.clearCategoryList());
      } else {
        const data = {
          pageNumber: 1,
          isGlobal: "",
          status: status,
        };
        props?.getategoryListData(data);
      }

      return newState;
    });
  };

  // code start for edit Global
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openPopModal, setOpenPopModal] = useState(false);

  const isShowClient =
    parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID) && checkPrivileges([12]);
  const showMenu = showRighSideMenu();
  const showSafety =
    showMenu?.isSafety &&
    (isShowClient || hasAllPrivileges(SEFETY_HBN_CLIENT_PARTNER_PRI));

  const showSW =
    showMenu?.isSW &&
    (isShowClient || hasAllPrivileges(SW_HBN_CLIENT_PARTNER_PRI));

  const isShowClientClone = parseInt(ORG_ID()) !== parseInt(HBNEXT_ORG_ID);
  const CloneshowSafety =
    showMenu?.isSafety &&
    (isShowClientClone || hasAllPrivileges(SEFETY_HBN_CLIENT_PARTNER_PRI));

  const showSWClone =
    showMenu?.isSW &&
    (isShowClientClone || hasAllPrivileges(SW_HBN_CLIENT_PARTNER_PRI));
  const checkClientPartner =
    hasAllPrivileges(SEFETY_HBN_CLIENT_PARTNER_PRI) ||
    hasAllPrivileges(SW_HBN_CLIENT_PARTNER_PRI);
  const handleChange = (event, newValue) => {
    setSearch("");
    setSelectedValue();
    props?.setIscloneBtnClick(false);
    setPage(0);
    setPageSize(GRID_DEFAULT_PAGE_SIZE);
    setValue(newValue);
    // setStatus(newValue);
    props?.setPublicStatus(false);
    const data = {
      pageNumber: 1,
      pageSize: GRID_DEFAULT_PAGE_SIZE,
      search: "",
      catIds: "",
      statusId: "",
      userId: USER_ID(),
      organisationId: ORG_ID(),
      status: newValue,
      isSendMail: false,
    };
    getCoursesListData(data);
  };

  const debouncedSearch = useDebounce(search, 500);
  const isFirstRender = React.useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (debouncedSearch === undefined) return;

    if (
      courseListData?.filterObj &&
      String(debouncedSearch || "") ===
        String(courseListData.filterObj.search || "")
    ) {
      return;
    }

    getCoursesListData({
      pageNumber: 1,
      pageSize,
      search: debouncedSearch,
      catIds: selectedValue || "",
      status: value,
      userId: USER_ID(),
      organisationId: ORG_ID(),
      isSendMail: false,
    });
  }, [debouncedSearch]);

  const handleClose = (event) => {
    event?.currentTarget.type === "button"
      ? setAnchorEl(event.currentTarget)
      : setAnchorEl(null);
  };

  const handleautoSearch = (event) => {
    let searchText = "";
    if (event.target.value) {
      searchText = event.target.value;
    }
    setSearch(searchText);

    setPage(0);
  };

  useEffect(() => {
    if (courseListData.status === API_STATUS.SUCCESS) {
      setisdisable(false);
    }
  }, [courseListData.status]);

  useEffect(() => {
    if (
      publishCourseStatus === API_STATUS.SUCCESS ||
      CoursedeleteStatus === API_STATUS.SUCCESS
    ) {
      dispatch(lmsAction.getCategoryList({ pageNumber: 1, isGlobal: false }));
      dispatch(
        lmsAction.getCoursesList({
          search: search,
          pageSize: pageSize,
          pageNumber: page + 1,
          catIds: selectedValue ? selectedValue : "",
          status: value ? value : "",
          organisationId: ORG_ID(),
          isSendMail: false,
        }),
      );
      handleClose();
    }
  }, [CoursedeleteStatus, publishCourseStatus]);

  useEffect(() => {
    if (
      props?.cloneCourseData?.status === API_STATUS.SUCCESS &&
      props?.iscloneBtnClick
    ) {
      props?.toast("Clone Course Successfully");

      dispatch(
        lmsAction.getCoursesList({
          search: search,
          pageSize: pageSize,
          pageNumber: page + 1,
          catIds: selectedValue ? selectedValue : "",
          status: value ? value : "",
          organisationId: ORG_ID(),
          isSendMail: false,
        }),
      );
      props?.setIscloneBtnClick(false);
      handleClose();
    }
  }, [props?.cloneCourseData]);

  const saveListStateBeforeNavigate = React.useCallback(() => {
    dispatch(
      lmsAction.getCoursesListFilterObj({
        pageNumber: page + 1,
        pageSize,
        search: search || "",
        catIds: selectedValue || "",
        status: value,
        userId: USER_ID(),
        organisationId: ORG_ID(),
        isSendMail: false,
        isActive: selectActive,
      }),
    );
  }, [page, pageSize, search, selectedValue, value, selectActive, dispatch]);

  const handleViewOnClick = (courseId) => {
    saveListStateBeforeNavigate();
    navigate(COURSESDETAIL, {
      state: {
        courseId: courseId,
        userId: USER_ID(),
        isAdminCourse: true,
        courseDetailBackPath: location?.pathname,
      },
    });
  };

  const publishItem = (courseId) => {
    dispatch(lmsAction.clearPublishCourse());
    const courseData = {
      courseId: courseId,
      isPulish: true,
      orgId: parseInt(ORG_ID()),
    };
    props?.setPublicStatus(true);
    props?.onSubmit(courseData);
    setAnchorEl(null);
  };

  const unPublishItem = (courseId) => {
    const courseData = {
      courseId: courseId,
      isPulish: false,
      orgId: parseInt(ORG_ID()),
    };
    props?.onSubmit(courseData);
    setAnchorEl(null);
  };

  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const deleteItem = (rows) => {
    if (InactiveClient()) return;
    setOpenModal(true);
    setSelectedRow(rows);
  };
  const deletehandle = () => {
    if (InactiveClient()) return;
    setOpenModal(false);
    const data = {
      courseId: selectedRow?.id,
    };
    deleteCourse(data);
  };
  const columns = React.useMemo(() => {
    const headers = [...COLUMNS_COURSES_VIEW];
    headers.push({
      field: "",
      width: 75,
      sortable: false,
      disableClickEventBubbling: true,
      filterable: false,
      disableColumnMenu: true,
      headerClassName: "course-action-header",
      renderCell: (rows) => {
        const DisablePublishBtn =
          rows.row?.isSaPublished === false &&
          rows.row?.isGlobal &&
          checkPrivileges([12, 11, 10]) &&
          parseInt(ORG_ID()) !== parseInt(HBNEXT_ORG_ID);

        return (
          <TableRowAction
            rows={rows}
            usingComp={"Course"}
            deleted={
              (!rows?.row?.isPublished &&
                checkPrivileges([12, 11]) &&
                isShowClient) ||
              (!rows?.row?.isPublished &&
                checkPrivileges([12, 11]) &&
                rows?.row?.isGlobal === false)
                ? "deleted"
                : ""
            }
            edit={
              (!rows?.row?.isPublished &&
                checkPrivileges([12, 11, 10]) &&
                isShowClient) ||
              (!rows?.row?.isPublished &&
                checkPrivileges([12, 11, 10]) &&
                rows?.row?.isGlobal === false) ||
              (rows?.row?.isGlobal &&
                !rows?.row?.isPublished &&
                (CloneshowSafety || showSWClone) &&
                checkClientPartner &&
                parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID) &&
                !DisablePublishBtn)
                ? "edit"
                : ""
            }
            view
            viewLabel={"View Course"}
            editLabel={"Edit Course"}
            deleteLabel={"Delete Course"}
            publishText={
              (rows?.row?.isPublished &&
                rows?.row?.isGlobal === false &&
                checkPrivileges([12, 11, 10])) ||
              (rows?.row?.isGlobal === true &&
                rows?.row?.isSaPublished === true &&
                rows?.row?.isPublished &&
                checkPrivileges([12, 11, 10])) ? (
                <span className={isdisable ? "disableclss" : ""}>
                  UnPublish Course{" "}
                </span>
              ) : (
                <span
                  className={
                    isdisable || DisablePublishBtn ? "disableclss" : ""
                  }
                >
                  Publish Course
                </span>
              )
            }
            publish={checkPrivileges([12, 11, 10]) ? "publish" : ""}
            viewOnClick={(row) => handleViewOnClick(row?.id)}
            editOnClick={(row) =>
              !row?.isPublished && !InactiveClient()
                ? ((showSafety || showSW) &&
                    row?.isGlobal &&
                    parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID)) ||
                  (rows?.row?.isGlobal &&
                    !rows?.row?.isPublished &&
                    (CloneshowSafety || showSWClone) &&
                    parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID))
                  ? editItem(rows?.row)
                  : (saveListStateBeforeNavigate(),
                    navigate(`/course/edit/${row?.id}`, {
                      state: { isCloneOf: row?.isCloneOf },
                    }))
                : undefined
            }
            deleteOnClick={() =>
              checkPrivileges([12, 11]) ? deleteItem(rows?.row) : ""
            }
            publishOnClick={(row) => {
              if (InactiveClient()) {
                return true;
              } else {
                if (!isdisable) {
                  return (row?.isPublished &&
                    row?.isGlobal === false &&
                    checkPrivileges([12, 11, 10])) ||
                    (row?.isGlobal === true &&
                      row?.isSaPublished === true &&
                      row?.isPublished &&
                      checkPrivileges([12, 11, 10]))
                    ? (showSafety ||
                        showSW ||
                        parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID)) &&
                      row?.isGlobal &&
                      (parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID) ||
                        checkPrivileges([12, 11, 10]))
                      ? unPublishItemPop(row)
                      : unPublishItem(row?.id)
                    : row?.isSaPublished === false &&
                        (showSafety ||
                          showSW ||
                          parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID)) &&
                        !DisablePublishBtn &&
                        checkPrivileges([12, 11, 10])
                      ? publishItem(row?.id)
                      : row?.isSaPublished === false &&
                          row?.isGlobal &&
                          checkPrivileges([12, 11, 10])
                        ? ""
                        : publishItem(row?.id);
                }
              }
            }}
            clone={
              (rows?.row?.isGlobal &&
                rows?.row?.isSaPublished &&
                rows?.row?.isPublished &&
                (CloneshowSafety || showSWClone) &&
                parseInt(ORG_ID()) !== parseInt(HBNEXT_ORG_ID)) ||
              (checkClientPartner &&
                parseInt(ORG_ID()) !== parseInt(LOGIN_ORG_ID()) &&
                rows?.row?.isGlobal &&
                rows?.row?.isSaPublished &&
                rows?.row?.isPublished)
                ? true
                : false
            }
            cloneLabel="Clone Course"
            cloneOnClick={() => handleCloneOnClick(rows?.row)}
          />
        );
      },
    });
    return headers;
  }, [
    courseListData,
    pageSize,
    navigate,
    isdisable,
    saveListStateBeforeNavigate,
  ]);
  const noRecourdCount = courseListData?.data?.noOfRecords;

  const handlePagignation = (newPage) => {
    setPage(newPage);
    getCoursesListData({
      pageNumber: newPage + 1,
      pageSize: pageSize,
      search: search,
      catIds: selectedValue ? selectedValue : "",
      status: value,
      userId: USER_ID(),
      organisationId: ORG_ID(),
      isSendMail: false,
    });
  };
  const handleSearch = () => {
    setPage(0);
    const data = {
      pageNumber: 1,
      pageSize: pageSize,
      search: search ? search : "",
      catIds: selectedValue,
      statusId: parseInt(value) === 0 ? 2 : parseInt(value) === 2 ? "" : 1,
      userId: parseInt(USER_ID()),
      orgId: parseInt(ORG_ID()),
      organisationId: ORG_ID(),
      status: value ? value : "",
      isActive: selectActive,
    };
    setAnchorEl(null);
    getCoursesListData(data);
  };
  const onChangeCategoryType = (item) => {
    setSelectedValue(item?.target?.value);
  };

  const handleClear = (item) => {
    setSelectedValue("");
    setSearch("");
    setPage(0);
    setPageSize(GRID_DEFAULT_PAGE_SIZE);
    getCoursesListData({
      pageNumber: 1,
      pageSize: GRID_DEFAULT_PAGE_SIZE,
      search: "",
      catIds: "",
      status: value,
      userId: USER_ID(),
      organisationId: ORG_ID(),
      isSendMail: false,
    });
    setAnchorEl(null);
    setOpen(false);

    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const open1 = Boolean(anchorEl);
  const id = open1 ? "simple-popover" : undefined;

  const sendEmail = () => {
    const data = {
      pageNumber: page,
      pageSize: pageSize,
      search: search,
      catIds: selectedValue ? selectedValue : "",
      status: value,
      userId: USER_ID(),
      organisationId: ORG_ID(),
      isSendMail: true,
    };
    getCoursesListData(data);
    dispatch(
      lmsAction.getCoursesListFilterObj({
        ...data,
        isSendMail: false,
      }),
    );
  };
  const handlePageSizeChange = (newPazeSize) => {
    setPage(0);
    setPageSize(newPazeSize);
    getCoursesListData({
      pageNumber: 1,
      pageSize: newPazeSize,
      search: search ? search : "",
      catIds: selectedValue ? selectedValue : "",
      status: value,
      userId: USER_ID(),
      organisationId: ORG_ID(),
      isSendMail: false,
    });
  };
  // Edit Global content Course

  const editItem = (rows) => {
    if (InactiveClient()) return;
    setOpenEditModal(true);
    setSelectedRow(rows);
  };

  const edithandle = (rows) => {
    if (InactiveClient()) return;
    setOpenEditModal(false);
    if (!selectedRow?.isPublished && !InactiveClient()) {
      saveListStateBeforeNavigate();
      navigate(`/course/edit/${selectedRow.id}`);
    }
  };
  const unPublishItemPop = (rows) => {
    if (InactiveClient()) return;
    setOpenPopModal(true);
    setSelectedRow(rows);
  };
  const unpublishhandle = (rows) => {
    if (InactiveClient()) return;
    unPublishItem(selectedRow?.id);
    setOpenPopModal(false);
  };
  const handleCloneOnClick = (row) => {
    const data = { courseId: row?.id };
    props?.cloneCourse(data);
  };

  useEffect(() => {
    if (courseListData?.filterObj) {
      const f = courseListData.filterObj;
      setSearch(f.search || "");
      setSelectedValue(f.catIds || "");
      setPage((f.pageNumber || 1) - 1);
      setPageSize(f.pageSize || GRID_DEFAULT_PAGE_SIZE);
      const savedStatus = f.isActive;
      if (savedStatus === "ACTIVE") {
        setActiveInActive({ ACTIVE: true, INACTIVE: false });
      } else if (savedStatus === "INACTIVE") {
        setActiveInActive({ ACTIVE: false, INACTIVE: true });
      } else {
        setActiveInActive({ ACTIVE: false, INACTIVE: false });
      }
      props?.getategoryListData({
        pageNumber: 1,
        isGlobal: "",
        isActive: savedStatus || "",
      });
    }
  }, [courseListData?.filterObj]);

  return (
    <>
      <div className="couresList" data-testid="courses-list-page">
        <Grid container>
          <Grid lg={5.5} xs={12}>
            {openModal && (
              <DialogBox
                open={openModal}
                rows={[]}
                header={"Confirm Deletion"}
                deletehandle={deletehandle}
                handleCloseModal={() => setOpenModal(false)}
                content={"Are you sure you want to delete this Course?"}
                view
                testId="course-delete-dialog"
              />
            )}
            {openEditModal && (
              <DialogBox
                open={openEditModal}
                rows={[]}
                header={"Confirm Edit"}
                deletehandle={edithandle}
                handleCloseModal={() => setOpenEditModal(false)}
                content={
                  "These changes made will be shared with all clients. Are you sure you want to update?"
                }
                view
                editIcon={true}
                deleteIcon={false}
              />
            )}
            {openPopModal && (
              <DialogBox
                open={openPopModal}
                rows={[]}
                header={"Confirm UnPublish"}
                deletehandle={unpublishhandle}
                handleCloseModal={() => setOpenPopModal(false)}
                content={
                  "This training has been mapped to a client’s portal. Are you sure you want to unpublish?"
                }
                view
                editIcon={true}
                deleteIcon={false}
              />
            )}
            <Box>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  className="tabcustom"
                  icon={
                    value === 0 ? (
                      <div className="totalV">
                        {value === 0 ? noRecourdCount : ""}
                      </div>
                    ) : (
                      ""
                    )
                  }
                  iconPosition="end"
                  label="All Courses"
                />
                <Tab
                  className="tabcustom"
                  icon={
                    value === 1 ? (
                      <div className="totalV">
                        {value === 1 ? noRecourdCount : ""}
                      </div>
                    ) : (
                      ""
                    )
                  }
                  label="Published"
                  iconPosition="end"
                />
                <Tab
                  className="tabcustom"
                  icon={
                    value === 2 ? (
                      <div className="totalV">
                        {value === 2 ? noRecourdCount : ""}
                      </div>
                    ) : (
                      ""
                    )
                  }
                  label="Unpublished"
                  iconPosition="end"
                />
              </Tabs>
            </Box>
          </Grid>
          <Grid lg={6.5} xs={12}>
            <div className="rightFilter lmsDownloadData">
              <div className="div-download-email-right" onClick={sendEmail} data-testid="courses-download-btn">
                <span>
                  <img
                    src={downloadIcon}
                    className="DownLoadLogo"
                    alt="DownLoad Logo"
                  />
                </span>
                Download Data
              </div>

              <div className="filtertoolbox lmsCls">
                <div className="filter_of_caselisttoolBox">
                  <div className="searchcaseid">
                    <label htmlFor="search">
                      <span>
                        <SearchIcon />
                      </span>
                      <div>
                        <input
                          id="search"
                          data-testid="courses-search-input"
                          placeholder="Search"
                          type="text"
                          value={search}
                          className=""
                          onChange={handleautoSearch}
                          autoComplete="off"
                        />
                      </div>
                    </label>
                  </div>

                  <div className="filter_btn">
                    <button
                      aria-describedby={id}
                      variant="contained"
                      type="button"
                      name="btn"
                      onClick={(e) => handleClick(e)}
                    >
                      <FilterListIcon id="icn" /> Filters
                    </button>
                    <FilterCommonStatusSelect
                      id={id}
                      open={open1}
                      anchorEl={anchorEl}
                      handleClose={handleClose}
                      handleApply={handleSearch}
                      handleClear={handleClear}
                      filterDate={false}
                      filterSelect
                      categoryType={categoryListData?.categoryList ?? []}
                      categoryOnChanges={onChangeCategoryType}
                      category={selectedValue}
                      filterStatus={false}
                      resetBtn={true}
                      label={"Category"}
                      activeInActive={activeInActive}
                      setActiveInActive={setActiveInActive}
                      handleActiveInActiveChange={handleActiveInActiveChange}
                      statusCheckbox={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
        <Grid container>
          <TabPanel className="tabPanel" value={value} index={0}>
            {isTableLoading ? (
              ""
            ) : (
              <LmstableData
                courseListDataAll={courseListData}
                onPageChange={handlePagignation}
                page={page}
                isLoading={isLoading}
                columns={columns}
                handlePageSizeChange={handlePageSizeChange}
                pageSize={pageSize}
                tableClass={props.tableClass}
                value={value}
              />
            )}
          </TabPanel>
          <TabPanel className="tabPanel" value={value} index={1}>
            {isTableLoading ? (
              ""
            ) : (
              <LmstableData
                courseListDataAll={courseListData}
                onPageChange={handlePagignation}
                page={page}
                isLoading={isLoading}
                columns={columns}
                handlePageSizeChange={handlePageSizeChange}
                pageSize={pageSize}
                tableClass={props.tableClass}
                value={value}
              />
            )}
          </TabPanel>
          <TabPanel className="tabPanel" value={value} index={2}>
            {isTableLoading ? (
              ""
            ) : (
              <LmstableData
                courseListDataAll={courseListData}
                onPageChange={handlePagignation}
                page={page}
                isLoading={isLoading}
                columns={columns}
                handlePageSizeChange={handlePageSizeChange}
                pageSize={pageSize}
                tableClass={props.tableClass}
                value={value}
              />
            )}
          </TabPanel>
        </Grid>
      </div>
    </>
  );
};

export default CoursesList;
